var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-chip',{attrs:{"label":_vm.label,"size":_vm.size,"removable":_vm.removable,"clickable":_vm.clickable,"color":_vm.color,"text-color":"white"},on:{"remove":function($event){return _vm.remove(_vm.id)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }